/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
export var DIRECTION_ROW = 'row';
export var DIRECTION_COLUMN = 'column';

export var ANCHOR_TOP = 'top';
export var ANCHOR_TOP_RIGHT = 'top-right';
export var ANCHOR_RIGHT = 'right';
export var ANCHOR_BOTTOM_RIGHT = 'bottom-right';
export var ANCHOR_BOTTOM = 'bottom';
export var ANCHOR_BOTTOM_LEFT = 'bottom-left';
export var ANCHOR_LEFT = 'left';
export var ANCHOR_TOP_LEFT = 'top-left';
export var ANCHOR_CENTER = 'center';

export var DIRECTION_LEFT_TO_RIGHT = 'left-to-right';
export var DIRECTION_RIGHT_TO_LEFT = 'right-to-left';
export var DIRECTION_TOP_TO_BOTTOM = 'top-to-bottom';
export var DIRECTION_BOTTOM_TO_TOP = 'bottom-to-top';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nivo/legends/es/constants.js
// module id = 113
// module chunks = 0